import { Component, OnInit, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DrugSelectionComponent } from '../../modals/drug-selection/drug-selection.component';
import { PortalService } from '../../../../../services/portal.service';
import { Router } from '@angular/router';
import { EnrollmentFormService } from '../../../../../services/EnrollmentFormService';

import { SuccessComponent } from '../../modals/enrollment-success/success.component';
import { EnrollmentFailureComponent } from '../../modals/enrollment-failure/enrollment-failure.component';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { UploadMissingDocumentComponent } from '../../modals/upload-missing-document/upload-missing-document.component';
@Component({
  selector: 'app-submissions',
  templateUrl: './submissions.component.html',
  styleUrl: './submissions.component.scss'
})
export class SubmissionsComponent implements OnInit {
  patientData: any;
  patientSubmissions: any;
  drugList: any;
  isLoading: boolean = true;
  patientAccountId: any;
  imageSrc: string = 'assets/images/mobile/Enrollmentmobile.png';
  constructor(private dialog: MatDialog, private portalService: PortalService, private router: Router, private efs: EnrollmentFormService) { }

  ngOnInit() {
    this.patientAccountId = this.getPatientAccountId('patientAccountId');
    this.getPatientSubmissionListById();
  }
  getPatientAccountId(value: any): number | null {
    const storedId = localStorage.getItem(value);
    return storedId ? parseInt(storedId, 10) : null;
  }

  openModal(): void {
    const dialogRef = this.dialog.open(DrugSelectionComponent, {
      minWidth: '50vw', minHeight: '70vh', autoFocus: false, disableClose: true,
    });


    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('User selected:', result);
        localStorage.setItem('CurrentEnrollmentStep', '1');
      } else {
        console.log('Modal closed without selection');
      }
    });
  }

  continue(enrollment: any) {
    console.log(enrollment);
    this.isLoading = true;
    this.efs.resetForm();
    const route = this.efs.getRouteFromSequence(enrollment.lastEnrollmentStep);
    localStorage.setItem('CurrentEnrollmentStep', enrollment.lastEnrollmentStep);
    this.portalService.getEnrollmentById(null, enrollment.enrollmentId).subscribe((res) => {
      this.isLoading = false;
      this.efs.patchEnrollmentForm(res);
      this.router.navigate(['/enrollment/' + enrollment.enrollmentId + route.enrollmentRoute]);
    });
  }

  uploadDocument(enrollmentId:any){
    console.log('Opening dialog with EnrollmentID:', enrollmentId); // Debug log

    const dialogRef = this.dialog.open(UploadMissingDocumentComponent, {
      data: { enrollmentId },
      minWidth: '50vw',
      minHeight: '70vh',
      autoFocus: false,
      disableClose: true,
    });


    dialogRef.afterClosed().subscribe((result) => {
      if(result) this.getPatientSubmissionListById();
    });
  }

  getPatientSubmissionListById() {
    this.isLoading = true;
    this.portalService.getPatientSubmissionsByPatientId(this.patientAccountId).subscribe((data: any) => {
      console.log(data);
      if (data) {
        this.patientData = data;
        this.patientAccountId = data.patientAccountId;
        this.patientSubmissions = data.patientSubmissions;
      }
      this.isLoading = false;
    });
  }

  getDrugList() {
    this.portalService.getDrugList().subscribe((data: any) => {
      if (data) {
        this.drugList = data;
      }
    })
  }
}
